import { default as HomePublica, default as HomePublicaLayout } from 'components/Layout/HomePublica';
import AP_ROUTES from 'containers/AccidentesPersonales/ap.routes';
import AUTO_ROUTES from 'containers/Auto/auto.routes';
import CASUALTY_GENERAL_ROUTES from 'containers/Casuality-General/casualty-general.routes';
import CASUALITY_ROUTES from 'containers/Casuality/casualty.routes';
import CYBER_ROUTES from 'containers/Cyber/cyber.routes';
import DO_ROUTES from 'containers/DO/do.routes';
import FacturacionForm from 'containers/DatosFacturacionQr/FormularioFacturacionGeneral';
import { FormularioFact } from 'containers/DatosFacturacionQr/constants';
import FqasPage from 'containers/Faqs/Faqspage';
import { FAQS } from 'containers/Faqs/constants';
import GarantiaEntendidaPage from 'containers/GarantiaExtendida';
import ErrorPage from 'containers/General/ErrorPage';
import HOGAR_ROUTES from 'containers/Hogar/hogar.routes';
import HOME_ROUTES from 'containers/HomeMex/home.routes';
import RCPA_ROUTES from 'containers/LineasFinancieras/rcpa.routes';
import CargaMasivaCertificadosPoliza from 'containers/ListadoPolizas/CargaMasiva/CargaMasivaCertificadosPoliza';
import DetallePoliza from 'containers/ListadoPolizas/Detalle';
import DetalleCertificados from 'containers/ListadoPolizas/Detalle/DetalleCertificados';
import SSOError from 'containers/LoginMex/SSOError';
import MARINE_ROUTES from 'containers/MarineInland/marine.routes';
import ConfirmarPagoOnline from 'containers/Polizas/ConfirmarPagoOnline';
import POLIZAS_ROUTES from 'containers/Polizas/polizas.routes';
import PYMES_ROUTES from 'containers/Pymes/pymes.routes';
import RCP_ROUTES from 'containers/RCP/rcp.routes';
import SKT_ROUTES from 'containers/Segurykids/skt.routes';
import TBTA_ROUTES from 'containers/TravelMex/tbta.routes';
import React, { Suspense } from 'react';
import { Route } from 'react-router';
import { BrowserRouter, Redirect, Switch } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import CambiarContraseniaContainer from '../containers/CambiarContraseña/CambiarContraseniaContainer';
import RecuperarContraseniaLoginContainer from '../containers/CambiarContraseña/CambiarContraseniaLoginContainer';
import TokenCambioInvalidoContainer from '../containers/CambiarContraseña/TokenCambioInvalidoContainer';
import ContainerListadoCotizaciones from '../containers/ListadoCotizaciones/ContainerListadoCotizaciones';
import ContainerListadoPolizas from '../containers/ListadoPolizas/ContainerListadoPolizas';
import ContainerLoginMex from '../containers/LoginMex/ContainerLoginMex';
import containerLogout from '../containers/LoginMex/ContainerLogout';
import ContainerEmisionAsegurado from '../containers/Polizas/ContainerEmisionAsegurado';
import ContainerEmisionContratante from '../containers/Polizas/ContainerEmisionContratante';
import ContainerPagoTBTA from '../containers/Polizas/Pago/ContainerPagoTBTA';
import RecuperarContraseniaContainer from '../containers/RecuperarContrasenia/RecuperarContraseniaContainer';
import ContainerFinalCompra from '../containers/TravelMex/ContainerFinalCompra';
import ContainerRecuperarPoliza from '../containers/TravelMex/ContainerRecuperarPoliza';
import PerfilContainer from '../containers/perfil/PerfilContainer';
import EmptyLayout from './Layout/EmptyLayout';
import LayoutRoute from './Layout/LayoutRoute';
import PrivateLayoutRoute from './Layout/PrivateLayoutRoute';
import LoginF2M from './LoginMex/LoginF2M';

const Main = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<div />}>
        <Switch>
          <Route path="/garantia-extendida" component={GarantiaEntendidaPage} />
          <LayoutRoute
            exact={true}
            path="/logout"
            layout={EmptyLayout}
            component={containerLogout}
            carritovisible={false}
          />

          {/* ADMIN */}

          {/* LISTADO POLIZAS */}
          <PrivateLayoutRoute
            exact={true}
            path="/listado-cotizaciones"
            layout={HomePublicaLayout}
            component={ContainerListadoCotizaciones}
          />

          <PrivateLayoutRoute
            exact={true}
            path="/listado-pre-polizas"
            layout={HomePublicaLayout}
            component={ContainerListadoPolizas}
          />

          <PrivateLayoutRoute
            exact={true}
            path="/listado-polizas"
            layout={HomePublicaLayout}
            component={ContainerListadoPolizas}
          />

          <PrivateLayoutRoute
            exact={true}
            path="/listado-polizas-certificados"
            layout={HomePublicaLayout}
            component={ContainerListadoPolizas}
          />

          <PrivateLayoutRoute
            exact={true}
            path="/detalle-poliza/:idPoliza"
            layout={HomePublicaLayout}
            component={DetallePoliza}
          />

          <PrivateLayoutRoute
            exact={true}
            path="/detalle-poliza-plan/:idPoliza/:codPlan"
            layout={HomePublicaLayout}
            component={DetalleCertificados}
          />

          <PrivateLayoutRoute
            exact={true}
            path="/carga-masiva/:idPoliza/:codPlan"
            layout={HomePublicaLayout}
            component={CargaMasivaCertificadosPoliza}
          />

          <LayoutRoute
            exact={true}
            path="/recuperar-poliza"
            layout={HomePublicaLayout}
            component={ContainerRecuperarPoliza}
          />

          {/* END LISTADO POLIZAS */}

          <LayoutRoute exact={true} path="/fin-compra" layout={HomePublicaLayout} component={ContainerFinalCompra} />

          {/* FIN ADMIN */}
          <LayoutRoute
            exact={true}
            path="/recuperar-contrasenia"
            layout={HomePublicaLayout}
            component={RecuperarContraseniaContainer}
          />

          <PrivateLayoutRoute exact={true} path="/mi-perfil" layout={HomePublicaLayout} component={PerfilContainer} />

          <LayoutRoute
            exact={true}
            path="/actualizar-contrasenia"
            layout={HomePublicaLayout}
            component={RecuperarContraseniaLoginContainer}
          />

          <LayoutRoute
            exact={true}
            path="/token-invalido"
            layout={HomePublicaLayout}
            component={TokenCambioInvalidoContainer}
          />

          <PrivateLayoutRoute
            exact={true}
            path="/cambiar-contrasenia"
            layout={HomePublicaLayout}
            component={CambiarContraseniaContainer}
          />

          <PrivateLayoutRoute
            exact={true}
            path="/cambio-contrasenia-caducada"
            layout={EmptyLayout}
            component={RecuperarContraseniaLoginContainer}
            validarToken={false}
            redirect="/"
            title="Contraseña Caducada"
          />

          <LayoutRoute exact={true} path="/login" layout={EmptyLayout} component={ContainerLoginMex} />
          <LayoutRoute exact={true} path="/login-old" layout={EmptyLayout} component={ContainerLoginMex} />
          <LayoutRoute exact={true} path="/sso/error" layout={HomePublicaLayout} component={SSOError} />
          <LayoutRoute exact={true} path="/auth/sso/ingresar" layout={HomePublicaLayout} component={LoginF2M} />

          {HOME_ROUTES}

          {/* URLs de los cotizadores y que el usuario necesitar estar logueado para acceder  */}
          {TBTA_ROUTES}
          {/*FIN TRAVEL EMPRESAS*/}

          {/*ACCIDENTES PERSONALES*/}

          {AP_ROUTES}

          {/* POLIZAS */}

          <LayoutRoute
            exact
            path="/emision-contratante"
            layout={HomePublicaLayout}
            component={ContainerEmisionContratante}
          />

          <LayoutRoute
            exact
            path="/emision-asegurado"
            layout={HomePublicaLayout}
            component={ContainerEmisionAsegurado}
          />

          {/* <LayoutRoute exact={true} path="/pago" layout={HomePublicaLayout} component={ContainerPagoTBTA} /> */}

          {/*AUTO*/}

          {AUTO_ROUTES}

          {/* FIN AUTO*/}

          {/* INICIO HOGAR */}
          {HOGAR_ROUTES}
          {/* FIN HOGAR */}

          {/* INCIO LINEAS FINANCIERAS */}
          {RCPA_ROUTES}
          {/* FIN LINEAS FINANCIERAS */}

          {/* INCIO RCP */}
          {RCP_ROUTES}
          {/* FIN LINEAS FINANCIERAS */}

          {/* CYBER */}
          {CYBER_ROUTES}
          {/* FIN CYBER */}

          {/* D&O */}
          {DO_ROUTES}
          {/* FIN D&O */}

          {/* INICIO MARINES INLAND */}
          {MARINE_ROUTES}
          {/* FIN MARINES INLAND */}

          {/* INICIO CAUSALITY */}
          {CASUALITY_ROUTES}
          {/* FIN CAUSALITY */}

          {/* INICIO CAUSALITY COTIZACIONES GENERALES */}

          {CASUALTY_GENERAL_ROUTES}

          {/* FIN CAUSALITY COTIZACIONES GENERALES */}

          {/* SEGUKIDS */}
          {SKT_ROUTES}

          {/* FIN SEGUKIDS */}

          {/* CARGA QR */}
          <LayoutRoute exact path={FormularioFact.urls.path} layout={HomePublicaLayout} component={FacturacionForm} />

          {/* FIN CARGA QR  */}

          {/* FAQS*/}
          <LayoutRoute exact={true} path={FAQS.urls.faqSeccion} layout={HomePublicaLayout} component={FqasPage} />
          {/* FIN FAQS*/}

          <LayoutRoute exact path="/error-page/:errorCode" layout={HomePublicaLayout} component={ErrorPage} />

          <LayoutRoute
            exact
            path="/confirmar-pago-online/:idPoliza/:codProducto/:tokenCorreo/:sessionId/:canal"
            layout={HomePublica}
            component={ConfirmarPagoOnline}
          />
          {/* INCIO PYMES */}
          {PYMES_ROUTES}
          {/* FIN PYMES */}
          {POLIZAS_ROUTES}

          <Redirect to="/?in-progress=true" />

          {/**********************************  FIN AIG MEX ****************************************************************************************************************************************************************/}
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Main;
